// extracted by mini-css-extract-plugin
var _1 = "UserInformationEdit_field__0SBlB";
var _2 = "UserInformationEdit_text__KQgCF";
export { _1 as "field", _2 as "text" }
